import React from 'react';
import { ShieldOff } from 'lucide-react';
import { useCamp } from '../contexts/CampContext';
import { useAuth } from '../contexts/AuthContext';

export default function PermissionGuard({ require: key, children }) {
  const { hasPermission, loading } = useCamp();
  const { user } = useAuth();

  if (loading) return <div className="page-loading"><div className="spinner" /></div>;
  if (!user) return null;
  if (!hasPermission(key)) return <NoPermissionPage permKey={key} />;
  return children;
}

function NoPermissionPage({ permKey }) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', padding: '80px 24px', textAlign: 'center',
    }}>
      <ShieldOff size={48} style={{ opacity: 0.15, marginBottom: 20, color: 'var(--color-muted)' }} />
      <h2 style={{
        fontFamily: 'var(--font-display)', fontWeight: 900, fontSize: '1.4rem', marginBottom: 8,
        color: 'var(--color-text)',
      }}>Kein Zugriff</h2>
      <p style={{ color: 'var(--color-muted)', maxWidth: 340 }}>
        Du hast keine Berechtigung für diesen Bereich. Wende dich an einen Administrator.
      </p>
      <div style={{
        marginTop: 8, fontSize: '0.75rem', color: 'var(--color-muted)',
        fontFamily: 'monospace', opacity: 0.5,
      }}>{permKey}</div>
    </div>
  );
}
